// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__UHuIV","right":"Footer_right__8II4_","buttons":"Footer_buttons__2vgT9"};